import React, { Fragment } from "react";

const About = () => {
	return (
		<Fragment>
			<h1>About QuickHub</h1>
			<p>
				QuickHub allows you to search GitHub users and get the information you
				need plain and simple.
			</p>
			<p>Version: 1.0.0</p>
		</Fragment>
	);
};

export default About;
